import { useLocalStorage } from "usehooks-ts";

// ponytail: per-browser storage, move to a profile API if replies should follow the user across devices
export function useSavedReplies() {
	const [replies, setReplies] = useLocalStorage<string[]>(
		"taskhub:saved-replies",
		[],
	);

	return {
		replies,
		add(text: string) {
			const reply = text.trim();
			if (reply && !replies.includes(reply)) setReplies([...replies, reply]);
		},
		remove(reply: string) {
			setReplies(replies.filter((r) => r !== reply));
		},
	};
}
